var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7891 7.89066L8.75155 1.85629L8.34687 1.4516C8.25466 1.36 8.12996 1.30859 7.99999 1.30859C7.87002 1.30859 7.74532 1.36 7.65312 1.4516L1.21093 7.89066C1.11645 7.98478 1.04178 8.09687 0.991323 8.22031C0.940871 8.34376 0.91566 8.47606 0.917179 8.60941C0.923429 9.15941 1.38124 9.59848 1.93124 9.59848H2.5953V14.6875H13.4047V9.59848H14.0828C14.35 9.59848 14.6016 9.49379 14.7906 9.30473C14.8837 9.21193 14.9575 9.10159 15.0076 8.98009C15.0578 8.8586 15.0833 8.72836 15.0828 8.59691C15.0828 8.33129 14.9781 8.07973 14.7891 7.89066ZM8.87499 13.5625H7.12499V10.375H8.87499V13.5625ZM12.2797 8.47348V13.5625H9.87499V10C9.87499 9.65473 9.5953 9.37504 9.24999 9.37504H6.74999C6.40468 9.37504 6.12499 9.65473 6.12499 10V13.5625H3.7203V8.47348H2.2203L8.00155 2.69691L8.36249 3.05785L13.7812 8.47348H12.2797Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.e46589433fb357f545daecab95547e97.svg";
export { ForwardRef as ReactComponent };